module.exports = __webpack_public_path__ + "8ad2abd0b5999dca90482af4ad2bbc3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/img/close-icon.png
// module id = 23
// module chunks = 0